$(document).ready(function(){
  "use strict";
  $('ul.tabs li').click(function(){
    var tab_id= $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');    
  })
})

$(document).ready(function($) {
  "use strict";
  $( "body" ).on( "click", ".accordion_hand", function() {
      
      if( $( this ).hasClass( "active" ) ){
        $( this ).removeClass( "active" );
        $( this ).next().removeClass( "active" );
      }else{
        $( ".accordion_hand" ).removeClass( "active" );
        $( ".accordion_content" ).removeClass( "active" );
        
        $( this ).addClass( "active" );
        $( this ).next().addClass( "active" );
      }
  });
});

jQuery(document).ready(function($) {
    "use strict";

    // Initialize the first tab and content as active
    $(".tab_hand").first().addClass('current active');
    $($(".tab_hand").first().attr('data-content')).addClass('active');
    
    $('body').on( "click", '.tab_hand', function(event) {
      event.preventDefault();
      $(".tab_hand").removeClass('active');
      $(".tab_content").removeClass('active');
      
      $(this).addClass('active');
      $($(this).attr('data-content')).addClass('active');
      
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var variantInputs = document.querySelectorAll('.variant-radio-input');
    variantInputs.forEach(function(input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          let get_variant_id = input.getAttribute('data-variant-id');

          //Change product subtitle base on variant
          let productSubitle_selector = document.getElementById('product_subtitle_'+get_variant_id);
          let productSubitle = productSubitle_selector.innerHTML;
          $('.sub-title').empty().html(productSubitle);

          //Change product tabs base on variant
          let productTab_selector = document.getElementById('product_tabs_'+get_variant_id);
          let productTab = productTab_selector.innerHTML;
          $('.product__ddiln_waper').empty().html(productTab);


          //After media icons #1
          let productAfterMediaIcons_1_selector = document.getElementById('product_after_media_icon_1_'+get_variant_id);
          let productAfterMediaIcons_1_html = productAfterMediaIcons_1_selector.innerHTML;
          let productAfterMediaIcons_1_place = $('.product__after_media_icon_1');
          if(productAfterMediaIcons_1_html.includes("<hide>")){
            productAfterMediaIcons_1_place.css('display', 'none');
          }else{
            productAfterMediaIcons_1_place.css('display', 'block');
          }
          $(productAfterMediaIcons_1_place).empty().html(productAfterMediaIcons_1_html);

          //After media icons #2
          let productAfterMediaIcons_2_selector = document.getElementById('product_after_media_icon_2_'+get_variant_id);
          let productAfterMediaIcons_2_html = productAfterMediaIcons_2_selector.innerHTML;
          let productAfterMediaIcons_2_place = $('.product__after_media_icon_2');
          if(productAfterMediaIcons_2_html.includes("<hide>")){
            productAfterMediaIcons_2_place.css('display', 'none');
          }else{
            productAfterMediaIcons_2_place.css('display', 'block');
          }
          $(productAfterMediaIcons_2_place).empty().html(productAfterMediaIcons_2_html);

          //After media icons #3
          let productAfterMediaIcons_3_selector = document.getElementById('product_after_media_icon_3_'+get_variant_id);
          let productAfterMediaIcons_3_html = productAfterMediaIcons_3_selector.innerHTML;
          let productAfterMediaIcons_3_place = $('.product__after_media_icon_3');
          if(productAfterMediaIcons_3_html.includes("<hide>")){
            productAfterMediaIcons_3_place.css('display', 'none');
          }else{
            productAfterMediaIcons_3_place.css('display', 'block');
          }
          $(productAfterMediaIcons_3_place).empty().html(productAfterMediaIcons_3_html);

          //After media icons #4
          let productAfterMediaIcons_4_selector = document.getElementById('product_after_media_icon_4_'+get_variant_id);
          let productAfterMediaIcons_4_html = productAfterMediaIcons_4_selector.innerHTML;
          let productAfterMediaIcons_4_place = $('.product__after_media_icon_4');
          if(productAfterMediaIcons_4_html.includes("<hide>")){
            productAfterMediaIcons_4_place.css('display', 'none');
          }else{
            productAfterMediaIcons_4_place.css('display', 'block');
          }
          $(productAfterMediaIcons_4_place).empty().html(productAfterMediaIcons_4_html);

          /*
          setTimeout(function() {
            //Hide prive-widget for sould-out variant
            if($('.product-form__submit').prop('disabled')){
              $('#prive-widget-injection-point').css({
                'height': 'auto',
                'overflow': 'unset',
                'opacity' : "1"
              });
            }else{
              $('#prive-widget-injection-point').css({
                'height': '1px',
                'overflow': 'hidden',
                'opacity' : "0"
              });
            }
           }, 2000);


          //Add sould-out text to the button for sould-out variant
         setTimeout(function() {
            let souldOutText = $('<em>', {
              class: 'sould_out_text',
              text: 'SOLD OUT'
            });
            
            if($('.product-form__submit').prop('disabled')){
              
              $('.product-form__submit span').css({
                'font-size': '13px',
                  'overflow': 'unset',
                  'opacity' : "1"
              });
              $('.product-form__submit .sould_out_text').remove();
            }else{

              $('.product-form__submit').append(souldOutText);
              $('.product-form__submit span').css({
                'font-size': '0px',
                  'overflow': 'hidden',
                  'opacity' : "0"
              });
              $('.product-form__submit em').css({
                'font-style': 'normal',
              });
              
            }
         }, 2000); // 3000 milliseconds = 3 seconds
          */
        }
      });
    });
  });


/*
  When a sold out product load. 
  this block of code will hide the prive widget
  and add "SOULD OUT" text to the button of the product
====================
$(document).ready(function ($) {
  if($('.product-form__submit').prop('disabled')){
    let souldOutText = $('<em>', {
      class: 'sould_out_text',
      text: 'SOLD OUT'
    });
    $('.product-form__submit').append(souldOutText);
    $('.product-form__submit span').css({
      'font-size': '0px',
      'overflow': 'hidden',
      'opacity' : "0"
    });
    $('.product-form__submit em').css({
      'font-style': 'normal',
    });
    $('#prive-widget-injection-point').css({
      'height': '1px',
      'overflow': 'hidden',
      'opacity' : "0"
    });
  }
});
*/

/*
  After Media Icons update on page load
====================
$(document).ready(function ($) {
  let get_variant_id = $('.product-variant-id').attr('value');

  let productAfterMediaIcons_1_selector = document.getElementById('product_after_media_icon_1_'+get_variant_id);
  let productAfterMediaIcons_1_html = productAfterMediaIcons_1_selector.innerHTML;
  let productAfterMediaIcons_1_place = $('.product__after_media_icon_1');
  if(productAfterMediaIcons_1_html.includes("<hide>")){
    productAfterMediaIcons_1_place.css('display', 'none');
  }else{
    productAfterMediaIcons_1_place.css('display', 'block');
  }
  $(productAfterMediaIcons_1_place).empty().html(productAfterMediaIcons_1_html);

  let productAfterMediaIcons_2_selector = document.getElementById('product_after_media_icon_2_'+get_variant_id);
  let productAfterMediaIcons_2_html = productAfterMediaIcons_2_selector.innerHTML;
  let productAfterMediaIcons_2_place = $('.product__after_media_icon_2');
  if(productAfterMediaIcons_2_html.includes("<hide>")){
    productAfterMediaIcons_2_place.css('display', 'none');
  }else{
    productAfterMediaIcons_2_place.css('display', 'block');
  }
  $(productAfterMediaIcons_2_place).empty().html(productAfterMediaIcons_2_html);

  let productAfterMediaIcons_3_selector = document.getElementById('product_after_media_icon_3_'+get_variant_id);
  let productAfterMediaIcons_3_html = productAfterMediaIcons_3_selector.innerHTML;
  let productAfterMediaIcons_3_place = $('.product__after_media_icon_3');
  if(productAfterMediaIcons_3_html.includes("<hide>")){
    productAfterMediaIcons_3_place.css('display', 'none');
  }else{
    productAfterMediaIcons_3_place.css('display', 'block');
  }
  $(productAfterMediaIcons_3_place).empty().html(productAfterMediaIcons_3_html);

  let productAfterMediaIcons_4_selector = document.getElementById('product_after_media_icon_4_'+get_variant_id);
  let productAfterMediaIcons_4_html = productAfterMediaIcons_4_selector.innerHTML;
  let productAfterMediaIcons_4_place = $('.product__after_media_icon_4');
  if(productAfterMediaIcons_4_html.includes("<hide>")){
    productAfterMediaIcons_4_place.css('display', 'none');
  }else{
    productAfterMediaIcons_4_place.css('display', 'block');
  }
  $(productAfterMediaIcons_4_place).empty().html(productAfterMediaIcons_4_html);
});
*/